export const getDaysWord = (i: number, t: any) => {
  if (i === 1) {
    return t('one_lid.day');
  }
  if (i >= 2 && i <= 4) {
    return t('one_lid.daysGenitive');
  }
  return t('one_lid.days');
};
